'use client';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { useArticleOnceData } from '@/entities/article';
import {
  ArticleOnceHead,
  ArticleOnceSubHead,
  ArticleOnceContent,
} from '@/widgets/article';

import styles from './blogOnce.module.scss';
import ArticleRecently from '../../widgets/article/ui/ArticleRecently/ArticleRecently';

interface BlogOnceProps {
  slug: string;
  breadcrumbs?: ReactNode;
}

const BlogOnce: FC<BlogOnceProps> = (props) => {
  const { slug, breadcrumbs } = props;
  const { data } = useArticleOnceData(slug);

  return (
    <main className={classNames('page', styles.blogOncePage)}>
      <div className={classNames('container', 'container--full-bleed')}>
        {data && (
          <>
            <div className="container__inner">
              <ArticleOnceHead value={data} />
              <ArticleOnceSubHead value={data} />
            </div>
            <ArticleOnceContent value={data} />
            <div className="container__inner">
              <ArticleRecently value={data} />
            </div>
          </>
        )}
      </div>
      <div className="container">{breadcrumbs}</div>
    </main>
  );
};

export default BlogOnce;
